module.exports = __webpack_public_path__ + "location_76x76.729c6bf3f845c3a8a7dd236273231c48.png";